module.exports = __webpack_public_path__ + "static/mango-4c86bf389fe15cc338b30e77035ad4cb.png";